module.exports = __webpack_public_path__ + "794f4306ad41352e972df44ec77dd46f.fbx";